import { useEffect } from 'react';

import { TabbedModuleSettings } from 'Deer/components/TabbedModuleSettings/TabbedModuleSettings';
import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { IntentDropdown } from 'Deer/intent/Reviews/components/IntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

const ReviewSettings = () => {
  const { moduleName } = useOrganisationSettings();
  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];
  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Company-reviews-settings',
      },
    });
  }, []);
  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <IntentDropdown
            showKebabMenu={false}
            breadcrumbs={{
              items: [
                {
                  label: 'Company',
                  to: applicableL2CompanyModules[0]?.value,
                },
              ],
              page: {
                label: 'Reviews',
                to: '',
              },
            }}
          />
        }
      >
        <TabbedModuleSettings />
      </Layout>
    );
  }

  return <TabbedModuleSettings />;
};

export { ReviewSettings };
